import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, matches } from 'lodash'; import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import { formFields, confirmationMessage, successfullyMessage, userFormFieldsData, options, statusOptions, countryLengthConstant, countryCodeConstant } from './constant';
import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import routes from '../../../../routes';
import Table from '../../../../components/CustomTable';
import Input from '../../../../components/FormElements/Input';
import SelectNew from '../../../../components/FormElements/SelectNew';
import ToastModal from "../../../../components/ToastModal";
import CreatableSelect from "../../../../components/CreatableSelect";
import Spinner from '../../../../components/Spinner';
import { withRouter, Link } from 'react-router-dom';
import { useFetchPlatformData } from "../../../../hooks/useFetchPlatformData";
import { getAdminUserListAction, editAccountAction, getUserListByEmailAction, postBalanceValueAction, getAdminRolesListAction, getAdminUserSingleListAction, getConfigurationDataAction, configAttributeAction, editTenantAction, addAccountAction, postProfileBalanceAction, postProfileBalanceDebitAction, postAddThirdPartySeatAction, postUserMappedSeatsAction, postMapDefaultSeatsAction, postTenantSupportedPaymentTypesAction, postTenantPaymentTypeAction, dispatchPreSignInData, getPreSignInDataAction } from '../../../../actions';
import { checkConnectionManagementAccess, encryptAuthData, encryptDataWithBlowfish, getTenantTimeZoneId, isApiCallSuccess, scrollToElement, sortArray } from "../../../../selectors";
import { message } from "antd";

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const Modal = asyncRoute(() => import('../../../../components/Modal'));
const Checkbox = asyncRoute(() => import('../../../../components/FormElements/Checkbox'));
const NewSeat = asyncRoute(() => import('../../../../components/NewSeat'));
const CampaignSync = asyncRoute(() => import('../../../../components/CampaignSync'));

function AddAccount(props) {
    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });

    const userFormFieldsError = { name: {}, contact: {}, email: {}, roleTenantList: {}, userStatus: {} };
    const userFormFieldsTouched = { name: {}, contact: {}, email: {}, roleTenantList: {}, userStatus: {} };
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({
        status: 1,
        creditType: 1,
        addCredit: 0
    });
    const [accountUsers, setAccountUsers] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [assignUsers, setAssignUsers] = useState([
        // { uID: "", roleTenantList: '', email: "", name: "", contact: "", userStatus: 1, suggestions: [], isNameSelected: false, errors: userFormFieldsError, touched: userFormFieldsTouched }
    ]);
    const [pspData, setPspData] = useState({});
    const [rolesList, setRolesList] = useState([]);
    const [parentTenant, setParentTenant] = useState({});
    const [tenantTypeList, setTenantTypeList] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [connectionManagement, setConnectionManagement] = useState(true);
    const [editedUser, setEditedUser] = useState({
        errors: {},
        touched: {}
    });
    const [seatData, setSeatData] = useState([]);
    const [campaignSyncVisible, setCampaignSyncVisible] = useState(false);
    const [selectedCampaignSyncAccount, setSelectedCampaignSyncAccount] = useState({});
    const [newSeat, setNewSeat] = useState(false);
    const [createdTenantId, setCreatedTenantId] = useState(null);
    const [currentBalance, setCurrentBalance] = useState(null);
    const platformData = useFetchPlatformData();
    const [showSpinner, setShowSpinner] = useState(false);
    const [isUserSaved, setIsUserSaved] = useState(false);
    const [userFormFields, setUserFormFields] = useState(userFormFieldsData);
    const [connectionManagementMiscData, setConnectionManagementMiscData] = useState(false);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [parentTenantBalance, setParentTenantBalance] = useState(null);

    const platformListOptions = {
        columns: [
            { id: 1, name: '', label: '', sortable: false, },
            { id: 2, name: 'platform', label: 'PLATFORM', sortable: false, type: 'string', component: (row) => (<div>{platformData && platformData.find(platform => platform.key == row.platformId).value}</div>) },
            { id: 3, name: 'accountName', label: 'ACCOUNT NAME', sortable: true, type: 'string', component: (row) => (<div>{row.accountName ? row.accountName : row.displayName}</div>) },
            {
                id: 4, name: 'accountId', label: 'ACCOUNT ID', sortable: true, type: 'number',
            },
            {
                id: 5, name: 'currency', label: 'CURRENCY', sortable: true, type: 'string', component: (row) => (<div>{row.currency}</div>)
            },
            { id: 6, name: 'status', label: 'STATUS', sortable: true, type: 'string', component: (row) => row.isRecActive == 1 ? <p className='badge bg-label-success'>Active</p> : <p className='badge bg-label-danger'>Inactive</p> },
        ],
        keyCol: 'aId',
        actions: [
            {
                type: 'sync',
                text: '',
                icon: 'ti ti-refresh color-beki',
                tooltip: 'Sync',
                iconType: 'new'
            },
        ],
        recActive: true,
        showSwitch: true,
        status: {
            key: 'isRecActive',
            active: '1',
            activeIcon: 'ti ti-toggle-left color-beki ti-lg',
            inActiveIcon: 'ti ti-toggle-right color-beki ti-lg',
            confirmation: true,
            activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
            inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
            type: 'recActive'
        },
        actionsThead: true,
        sortable: false,
        dateType: true,
        defaultSortParams: {
            sortBy: 'BaseCurrency',
            sortOrder: 'desc'
        },
        showSearch: false,
        searchable: true,
        searchColumns: [
            { key: 'AlternateCurrency' }
        ],
        paging: true,
        defaultPagingParams: {
            pageSize: 25
        }
    };

    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const configurationList = useSelector((state) => get(state, "app.configurationData.responseList", []));
    const tenantList = useSelector((state) => get(state, "app.preSignInData.responseList", []));
    const tenantType = useSelector((state) => get(state, "app.preSignInData.responseList[0].tenantType", ''));
    const accountTypeList = get(configurationList.find(item => item.attrName === 'TENANT_TYPE'), 'attributeValues', []);

    const { match: { path } } = props;
    if (path.includes(routes.admin.account.add)) {
        localStorage.removeItem('editAccountId');
    } else if (path.includes(routes.admin.account.add)) {
        const { match: { params: { id } } } = props;
        if (id) {
            localStorage.setItem('editAccountId', id);
        }
    }
    const id = localStorage.getItem('editAccountId');
    let isDefaultRoleDisabled = false;

    const dispatch = useDispatch();

    const toast = (status, msg, type) => {
        setToastModal({
            enableToast: true,
            toastStatus: status,
            toastMsg: msg
        });
        return;
    }

    const handleToastStatus = async (status) => {
        const { history } = props;
        setToastModal({
            ...toastModal,
            enableToast: status
        });
        if ((isUserSaved && id) || (isUserSaved && !connectionManagement)) {
            history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}`);
            return;
        }
        if (isUserSaved) {
            initialize();
        }
    };

    const confirmationCallbackModel = (id) => {
        setToastModal({
            ...toastModal,
            enableToast: false
        });
        handleSubmit();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[e.target.name] = value;
        setForm(newForm);
    };

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const handleEditedUserTouch = (e) => {
        const { error } = handleFieldError(e.target.value, userFormFields[e.target.name]);
        editedUser['errors'][e.target.name] = error;
        editedUser['touched'][e.target.name] = true;
    };

    const handleStatus = (row) => {
        let updatedUser = accountUsers.find(item => item.id === row.id);
        if (updatedUser) {
            if (updatedUser.roleTenantList[0].isRecActive === 0) {
                updatedUser.roleTenantList[0].isRecActive = 1;
                updatedUser.isRecActive = 1;
            } else if (updatedUser.roleTenantList[0].isRecActive === 1) {
                updatedUser.roleTenantList[0].isRecActive = 0;
                updatedUser.isRecActive = 0;
            }
            setAccountUsers(accountUsers.map(item => item.id === row.id ? updatedUser : item));
        }
    };

    const handleEdit = (row) => {
        setOpenModal(true);
        setEditedUser({
            ...editedUser,
            id: row.id,
            email: row.email,
            name: row.name,
            // name: { value: row.name, label: row.name },
            contact: row.contact,
            roleTenantList: Number(row.roleTenantList[0].roleId),
            userStatus: row.isRecActive,
            errors: {},
            touched: {}
        });
    };

    const handleAction = (row, action) => {
        if (action.type === 'edit') {
            handleEdit(row);
        } else if (action.type === 'recActive') {
            handleStatus(row);
        }
    }

    const handleMappedSeatStatus = async (row) => {
        let params = { addup: row.id };
        let payload = {
            thirdPartySeatRequest: {
                ...row,
                isRecActive: row.isRecActive == 1 ? 0 : 1
            }
        };
        await dispatch(postAddThirdPartySeatAction({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const { responseCode: { msg, status = '' }, responseObj } = data;
                if (status.toLowerCase() == "success" && responseObj && Object.keys(responseObj).length > 0) {
                    // console.log(responseObj);
                    toast(status, msg);
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const handlePlatformTableAction = (row, action) => {
        if (action.type === 'recActive') {
            handleMappedSeatStatus(row);
        } else if (action.type === 'sync') {
            setCampaignSyncVisible(true);
            setSelectedCampaignSyncAccount(row);
        }
    }

    const getAccountDetails = async (advertiserId) => {
        let accountDetails;
        await dispatch(editAccountAction({ tenantId, authToken, userId, editId: advertiserId }))
            .then((data) => {
                const { responseCode: { status }, responseList } = data;
                if (status.toLowerCase() == "success") {
                    accountDetails = responseList[0];
                    if (accountDetails && accountDetails.user && accountDetails.user.length > 0) {
                        accountDetails.user.map(item => {
                            item.isActive = item.roleTenantList[0].isActive
                            return item;
                        });
                    }
                } else {
                    console.log("Advertiser Details Not Found!");
                }
            }).catch((error) => {
                console.error(error);
            });
        return accountDetails;
    };

    const getAccountBalance = async (payload) => {
        let balance;
        await dispatch(postBalanceValueAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const { responseCode: { status = '' }, response } = data;
                if (isApiCallSuccess(status)) {
                    if (response && Object.keys(response).length > 0) {
                        balance = response.balance;
                    }
                }
            }).catch((error) => {
                console.error(error);
                balance = null;
            });
        return balance;
    };

    const getTenantSupportedPaymentTypes = async () => {
        try {
            let tenantSupportedPaymentTypes = [];
            let payload = { tenantId: Number(tenantId) };
            await dispatch(postTenantSupportedPaymentTypesAction({ tenantId, authToken, userId, payload }))
                .then((data) => {
                    const { responseCode: { status }, response } = data;
                    if (isApiCallSuccess(status) && response) {
                        tenantSupportedPaymentTypes = response.features.supportedPaymentType;
                    } else {
                        console.log("Tenant Supported Payment Types Not Found!");
                    }
                }).catch((error) => {
                    console.error(error);
                });
            return tenantSupportedPaymentTypes;
        } catch (e) {
            console.log(e);
        }
    };


    const getPaymentTypes = async () => {
        let supportedTypes = await getTenantSupportedPaymentTypes();
        if (supportedTypes && supportedTypes.length > 0) {
            await dispatch(configAttributeAction({ tenantId, authToken, userId, type: 'PAYMENT_TYPE' }))
                .then((data) => {
                    const { responseCode: { status }, responseList } = data;
                    if (isApiCallSuccess(status) && responseList && responseList.length > 0) {
                        let paymentTypes = responseList.filter(item => supportedTypes.includes(item.value));
                        paymentTypes = paymentTypes.map(item => ({ ...item, value: item.description }));
                        setPaymentTypes(paymentTypes);
                    } else {
                        console.log("Payment Type not found in config!");
                    }
                }).catch((error) => {
                    console.error(error);
                });
        }
    };

    const getUsersList = async () => {
        let params = { list: 'bytenant' };
        await dispatch(getAdminUserListAction({ tenantId, authToken, userId, params }))
            .then((data) => {
                const { responseCode: { status }, responseList } = data;
                if (status.toLowerCase() == "success") {
                    setUsersList(data.responseList);
                } else {
                    console.log("Users list not found!");
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const getRolesList = async () => {
        await dispatch(getAdminRolesListAction({ tenantId, authToken, userId, addParams: 'all' }))
            .then((data) => {
                const { responseCode: { status = '' }, response, responseList } = data;
                if (status && status.toLowerCase() == "success") {
                    setRolesList(responseList);
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const getPaymentConfig = async () => {
        if (configurationList && configurationList.length != 0) {
            const pspDataConfig = configurationList.find((data) => data.attrName == "PSP_LIST") || {}
            setPspData(pspDataConfig);
        } else {
            await dispatch(getConfigurationDataAction({ tenantId, authToken, userId }))
                .then((data) => {
                    const { responseCode: { status = '' }, responseList } = data;
                    if (status && status.toLowerCase() == "success" && responseList && responseList.length > 0) {
                        const pspDataConfig = responseList.find((data) => data.attrName == "PSP_LIST") || {};
                        setPspData(pspDataConfig);
                    }
                }).catch((error) => {
                    console.error(error);
                });
        }
    };

    const getTenantType = async () => {
        if (configurationList && configurationList.length != 0) {
            const tenantTypeList = get(configurationList.find(tenant => tenant.attrName === 'TENANT_TYPE'), 'attributeValues', []);
            setTenantTypeList(tenantTypeList);
        } else {
            await dispatch(configAttributeAction({ tenantId, authToken, userId, type: 'TENANT_TYPE' }))
                .then((data) => {
                    const { responseCode: { status = '' }, responseList } = data;
                    if (status && status.toLowerCase() == "success" && responseList && responseList.length > 0) {
                        setTenantTypeList(responseList);
                    }
                }).catch((error) => {
                    console.error(error);
                });
        }
    }

    const getUserDetails = async () => {
        await dispatch(getAdminUserSingleListAction({ tenantId, authToken, userId, id: userId }))
            .then((data) => {
                const { responseCode: { status = '' }, response, responseList } = data;
                if (status && status.toLowerCase() == "success" && responseList && responseList.length > 0) {
                    setForm((prevForm) => ({ ...prevForm, accountOwnerName: responseList[0].name, accountOwnerEmail: responseList[0].email }));
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const getSeatData = async (advId) => {
        let params = { list: 'mapped' };
        let payload = {
            thirdPartySeatRequest: {
                advertiserId: advId
            }
        };
        await dispatch(postUserMappedSeatsAction({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const { responseCode: { status }, response } = data;
                if (status.toLowerCase() == "success") {
                    setSeatData(response);
                } else {
                    console.log("Users mapped seats not found!");
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const onSeatMapped = () => {
        const { history } = props;
        setNewSeat(false);
        history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}/${routes.admin.account.view}/${createdTenantId}`);
        // getSeatData(createdTenantId);
    };

    const rolesDropdownValues = () => {
        const advertiserType = tenantTypeList && tenantTypeList.find(tenantType => tenantType.value.toLowerCase() == 'advertiser');
        const isActiveAndRoleType = role => role.isActive && role.tenantType == advertiserType.key && (role.roleType == 2 || role.roleType == 3);
        const rolesListFilterData = rolesList && rolesList.filter(isActiveAndRoleType);
        const myRolesList = rolesListFilterData ? rolesListFilterData : [];
        let myPublicRoles = tenantType == "Platform Manager" ? myRolesList : rolesList.filter(isActiveAndRoleType);

        if (openModal) {
            let hasRoleRestricted = myPublicRoles.some(({ roleId, roleType }) => editedUser[userFormFields.roleTenantList.key] == roleId && roleType == 3)
            if (hasRoleRestricted) {
                isDefaultRoleDisabled = true;
            } else {
                isDefaultRoleDisabled = false;
                myPublicRoles = myPublicRoles.filter(({ roleType }) => roleType == 2)
            }
        } else {
            myPublicRoles = myPublicRoles.filter(({ roleType }) => roleType == 2)
        }

        return myPublicRoles;
    };

    const getCreditTypeOptions = () => {
        let options = formFields[formFields.creditType.key].options;
        if (paymentTypes && paymentTypes.length > 0) {
            let selectedPaymentType = paymentTypes.find(paymentType => paymentType.key == form[formFields.paymentType.key]);
            if ((selectedPaymentType && selectedPaymentType.value.toLowerCase() == 'fix credit line') || Number(currentBalance) == 0) {
                options = options.filter(item => item.value !== 'Deduct');
            }
        }
        return options;
    }

    const isCreditTransferAllowed = () => {
        let check = false;
        if (paymentTypes && paymentTypes.length > 0) {
            let selectedPaymentType = paymentTypes.find(paymentType => paymentType.key == form[formFields.paymentType.key]);
            check = selectedPaymentType && selectedPaymentType.value.toLowerCase() == 'pre-paid only' ? false : true;
        }
        return check;
    }

    // Function to filter users based on whether they are already assigned or not
    const userDropdownValues = () => {
        // Extract the uIDs of already selected users
        let users = assignUsers;
        if (id) {
            let accountUsersWithUIDs = accountUsers.map(item => ({ ...item, uID: item.id }));
            users = [...assignUsers, ...accountUsersWithUIDs];
        }
        let alreadySelectedUsers = users.map(user => user.uID);
        // Variable to hold the filtered list of users
        let filteredUsers;
        // Check if there's only one user selected and his uID is empty string
        if (alreadySelectedUsers && alreadySelectedUsers.length === 1 && alreadySelectedUsers[0].uID === '') {
            // If true, map the entire usersList to match the required structure
            filteredUsers = usersList.map(user => ({ value: user.id, label: user.name }));
        } else {
            // Otherwise, filter out already selected users and map the remaining ones to match the required structure
            filteredUsers = usersList.filter(user => !alreadySelectedUsers.includes(user.id)).map(user => ({ value: user.id, label: user.name }));
        }
        // Return the filtered list of users
        return filteredUsers;
    };

    const addNewAdvertisers = () => {
        let newAdvertiser = { uID: "", roleTenantList: '', email: "", name: "", contact: "", userStatus: 1, suggestions: [], errors: userFormFieldsError, touched: userFormFieldsTouched, isNameSelected: false };
        let addUsersList = [...assignUsers, newAdvertiser];
        setAssignUsers(addUsersList);
    };

    const removeAssignedUser = (index) => {
        let addUsersList = [...assignUsers];
        addUsersList.splice(index, 1);
        setAssignUsers(addUsersList);
    };

    const getParentTenant = () => {
        let tenantNamesList = _.map(tenantList, (item) => ({ id: item.tenantId, text: item.tenantName }));
        const currentTenantType = tenantList.find(item => item.tenantId == tenantId)
        const parentTenant = tenantNamesList.find(item => item.id == currentTenantType.parentTenantId);
        setParentTenant(parentTenant);
    };

    const fetchPaymentType = async (id) => {
        let paymentType;
        let payload = { tenantId: id };
        await dispatch(postTenantSupportedPaymentTypesAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const { responseCode: { status }, response } = data;
                if (isApiCallSuccess(status) && response) {
                    if (response.hasOwnProperty('paymentMode')) {
                        paymentType = response['paymentMode']['id'];
                    }
                };
            }).catch((error) => {
                console.error(error);
            });
        return paymentType;
    };

    const mapAdvertiserPaymentType = async (id) => {
        let creditAmount = form[formFields.addCredit.key];
        let payload = {
            tenantId: id,
            paymentType: {
                creditAmount: creditAmount > 0 ? creditAmount : null,
                paymentMode: {
                    id: form[formFields.paymentType.key]
                },
                paymentCreditType: form[formFields.creditType.key] ? form[formFields.creditType.key] : null
            }
        };
        await dispatch(postTenantPaymentTypeAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const { responseCode: { status = '' } } = data;
                if (isApiCallSuccess(status)) {
                    console.log('Payment Type Mapped Successfully!');
                };
            }).catch((error) => {
                console.error(error);
            });
    };

    const editId = async (id) => {
        let accountDetails = await getAccountDetails(id);
        let paymentType = await fetchPaymentType(id);
        let balance = '';
        setAccountUsers(accountDetails.user);
        if (accountDetails) {
            let payload = { tenantId: accountDetails && accountDetails.accTenantId };
            balance = await getAccountBalance(payload);
        }
        if (accountDetails.hasOwnProperty('miscData')) {
            let miscData = accountDetails.miscData;
            const hasConnectionManagement = miscData.some(obj => obj.key === 'connectionManagement');
            if (hasConnectionManagement) {
                const connectionManagement = miscData.find(obj => obj.key === 'connectionManagement');
                if (connectionManagement && connectionManagement.value == 1) {
                    setConnectionManagement(true);
                } else {
                    setConnectionManagement(false);
                }
            }
        }
        setForm({
            ...form,
            accountName: accountDetails.accountName,
            accountOwnerName: accountDetails.contactPerson,
            accountOwnerEmail: accountDetails.email,
            status: accountDetails.isActive,
            accTenantId: accountDetails.accTenantId,
            [formFields.paymentType.key]: paymentType
        });
        setCurrentBalance(balance);
    };

    const getTenantDetails = async () => {
        let tenantDetails = {};
        await dispatch(editTenantAction({ tenantId, authToken, userId, editId: tenantId }))
            .then((data) => {
                const { responseCode: { status = '' }, response, responseList } = data;
                if (status && status.toLowerCase() == "success" && responseList && responseList.length > 0) {
                    tenantDetails = responseList;
                }
            }).catch((error) => {
                console.error(error);
            });
        return tenantDetails;
    };

    const mapDefaultSeats = async (id) => {
        let params = { map: 'default' };
        let payload = {
            thirdPartySeatRequest: {
                advertiserId: id
            }
        };
        await dispatch(postMapDefaultSeatsAction({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const { responseCode: { status = '' } } = data;
                if (status && status.toLowerCase() == "success") {
                    console.log('Default Seats Mapped Successfully');
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const refreshTenantList = async () => {
        try {
            let userLoginDetails = JSON.parse(localStorage.getItem('PreSignInState'));
            let { username, password } = userLoginDetails;
            if (username && password) {
                let data = await encryptDataWithBlowfish({ username, password });
                await dispatch(getPreSignInDataAction(data))
                    .then((responseData) => {
                        const { responseCode: { status = '' } } = responseData;
                        if (isApiCallSuccess(status)) {

                        }
                    }).catch((error) => {
                        console.error(error);
                    });
            }
        } catch (e) {
            console.log(e);
        }
    };

    const addAccount = async (data, addParams, id) => {
        let response;
        await dispatch(addAccountAction(tenantId, authToken, userId, data, addParams, id))
            .then((data) => {
                response = data;
            }).catch((error) => {
                console.error(error);
            });
        return response;
    };

    const addCreditToAdvertiser = async (payload, amount, pspId, toastMessage) => {
        await dispatch(postProfileBalanceAction({ tenantId, authToken, userId, payload, amount, pspID: pspId }))
            .then(async (data) => {
                const { responseCode: { status = '', msg = '' }, response } = data;
                if (status.toLowerCase() == "success") {
                    toast(status, `${toastMessage} ${msg}`);
                    setForm({ ...form, addCredit: 0 });
                } else {
                    if (msg == "Insufficient Wallet Balance!") {
                        const errorMessage = 'Entered amount is greater than the available wallet balance.';
                        toast('error', errorMessage);
                    } else if (msg == "User is not a manager") {
                        toast('error', msg);
                    } else {
                        const errorMessage = 'Advertiser has been created successfully. However, credits were not allocated to the advertiser due to some technical glitch.';
                        toast('error', errorMessage);
                    }
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const debitBalanceFromAdvertiser = async (payload, amount, pspId) => {
        await dispatch(postProfileBalanceDebitAction({ tenantId, authToken, userId, payload, amount, pspID: pspId }))
            .then(async (data) => {
                const { responseCode: { status = '', msg = '' }, response } = data;
                if (status.toLowerCase() == "success") {
                    toast(status, msg);
                    setForm({ ...form, addCredit: 0 });
                } else {
                    if (msg == "Insufficient Wallet Balance!") {
                        const errorMessage = 'Entered amount is greater than the available wallet balance.';
                        toast('error', errorMessage);
                    } else {
                        const errorMessage = 'Credits were not allocated to the advertiser due to some technical glitch.';
                        toast('error', errorMessage);
                    }
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const getAccountOwnerDetails = async (ownerEmail) => {
        let userData;
        const params = {
            list: "search",
            srch: ownerEmail.toLowerCase()
        };
        await dispatch(getUserListByEmailAction({ tenantId, authToken, userId, params })).then((responseData) => {
            const { responseCode: { status = "" }, responseList = [] } = responseData;
            if (isApiCallSuccess(status) && responseList && responseList.length > 0) {
                userData = responseList;
            }
        }).catch((err) => {
            console.log(err);
        })
        return userData;
    };

    const handleChangeUser = (e, index) => {
        const { name, value } = e.target;
        let updatedAssignedUsers = [...assignUsers];
        updatedAssignedUsers[index][name] = value;
        setAssignUsers(updatedAssignedUsers);
    };

    const handleCreatableUser = (selected, index) => {
        // Create a copy of the assignUsers array
        let updatedAssignUsers = [...assignUsers];
        // Get the current user from the assignUsers array
        let currentUser = updatedAssignUsers[index];
        // Update the properties of the current user
        currentUser[userFormFields.name.key] = selected;
        currentUser['uID'] = selected.value;
        currentUser['isNameSelected'] = true;
        // Check if the selected user is new
        if (selected.hasOwnProperty('__isNew__')) {
            currentUser['email'] = '';
            currentUser['contact'] = '';
        } else {
            // Find the user in the usersList
            let user = usersList.find(item => item.id === selected.value);
            // If the user exists, update their email and contact
            if (user) {
                currentUser['email'] = user.email;
                currentUser['contact'] = user.contact;
                searchEmailAndAssignId(userFormFields.email.key, user.email, index);
            } else {
                // If the user doesn't exist, remove the uID property
                currentUser['isNameSelected'] = false;
            }
        }
        // Update the assignUsers array with the modified user
        updatedAssignUsers[index] = currentUser;
        // Update the state with the modified assignUsers array
        setAssignUsers(updatedAssignUsers);
    };

    const validateAssignUsers = () => {
        let usersHasErrors = false;
        if (assignUsers && assignUsers.length > 0) {
            const areAllFieldsEmpty = assignUsers[0].name === "" && assignUsers[0].email === "" && assignUsers[0].contact === "" && assignUsers[0].roleTenantList === "";
            if (!areAllFieldsEmpty) {
                let updatedAssignUsers = assignUsers.map((user) => {
                    let updatedUser = { ...user };
                    if (user.email || user.email == null || user.email == '') {
                        const { error, isValid } = handleFieldError(user.email, userFormFields[userFormFields.email.key]);
                        updatedUser['errors'][userFormFields.email.key] = error;
                        updatedUser['touched'][userFormFields.email.key] = true;
                        usersHasErrors = !isValid;
                    }
                    if (user.name == '') {
                        updatedUser['errors'][userFormFields.name.key] = { required: true };
                        updatedUser['touched'][userFormFields.name.key] = true;
                        usersHasErrors = true;
                    }
                    // if (user.contact) {
                    //     const { error } = handleFieldError(user.contact, userFormFields[userFormFields.contact.key]);
                    //     updatedUser['errors'][userFormFields.contact.key] = error;
                    //     updatedUser['touched'][userFormFields.contact.key] = true;
                    //     usersHasErrors = true;
                    // }
                    if (user.roleTenantList == '') {
                        updatedUser['errors'][userFormFields.roleTenantList.key] = { required: true };
                        updatedUser['touched'][userFormFields.roleTenantList.key] = true;
                        usersHasErrors = true;
                    }
                    return updatedUser;
                });
                if (usersHasErrors == false) {
                    updatedAssignUsers = updatedAssignUsers.map(user => ({ ...user, errors: userFormFieldsError, touched: userFormFieldsTouched }));
                }
                setAssignUsers(updatedAssignUsers);
            }
        }
        return usersHasErrors;
    };

    const validateEditedUser = () => {
        let isValidUser = true;
        let newEditedUser = editedUser;
        if (newEditedUser) {
            if (newEditedUser.email || newEditedUser.email == null || newEditedUser.email == '') {
                const { error, isValid } = handleFieldError(newEditedUser.email, userFormFields[userFormFields.email.key]);
                newEditedUser['errors'][userFormFields.email.key] = error;
                newEditedUser['touched'][userFormFields.email.key] = true;
                isValidUser = isValid;
            }
            if (newEditedUser.name == '') {
                newEditedUser['errors'][userFormFields.name.key] = { required: true };
                newEditedUser['touched'][userFormFields.name.key] = true;
                isValidUser = false;
            }
            // if (user.contact) {
            //     const { error } = handleFieldError(user.contact, userFormFields[userFormFields.contact.key]);
            //     updatedUser['errors'][userFormFields.contact.key] = error;
            //     updatedUser['touched'][userFormFields.contact.key] = true;
            //     usersHasErrors = true;
            // }
            if (newEditedUser.roleTenantList == '') {
                newEditedUser['errors'][userFormFields.roleTenantList.key] = { required: true };
                newEditedUser['touched'][userFormFields.roleTenantList.key] = true;
                isValidUser = false;
            }
        }
        setEditedUser({ ...newEditedUser });
        return isValidUser;
    };

    const searchEmailAndAssignId = (name, value, index) => {
        try {
            const updatedAssignUsers = [...assignUsers];
            const user = assignUsers[index];
            let findUserDataExists = accountUsers.find((user) => user.email == value);
            let findAssignUserData = assignUsers.find((user, indexUser) => user.email == value && index != indexUser);
            if (findUserDataExists || findAssignUserData) {
                updatedAssignUsers[index][name] = '';
                message.error('Email already exists');
                setAssignUsers(updatedAssignUsers);
            }
            else {
                const params = {
                    list: "search",
                    srch: String(value).toLowerCase()
                }
                let userData = null;
                dispatch(getUserListByEmailAction({ tenantId, authToken, userId, params })).then((responseData) => {
                    const { responseCode: { status = "" }, responseList = [] } = responseData;
                    if (isApiCallSuccess(status)) {
                        if (responseList.length > 0) {
                            userData = responseList.find((user) => user.email.toLowerCase() == value.toLowerCase());
                        }
                        if (userData) {
                            updatedAssignUsers[index]["id"] = userData.id;
                            updatedAssignUsers[index]["isActive"] = userData.isActive ? userData.isActive : null;

                            // latest logic
                            updatedAssignUsers[index]['name'] = userData.name ? userData.name : '';
                        }
                        else {
                            updatedAssignUsers[index]["isActive"] = 1;
                            if (updatedAssignUsers[index].hasOwnProperty("id")) {
                                delete updatedAssignUsers[index]['id'];
                            }
                        }
                        setAssignUsers(updatedAssignUsers);
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleBlurAssignUser = (e, index) => {
        try {
            const updatedAssignUsers = [...assignUsers];
            const user = assignUsers[index];
            const { name, value } = e.target;
            if (user.name == '' || user.name == null) {
                updatedAssignUsers[index]['errors'][userFormFields.name.key] = { required: true };
                updatedAssignUsers[index]['touched'][userFormFields.name.key] = true;
            } else {
                updatedAssignUsers[index]['errors'][userFormFields.name.key] = {};
                updatedAssignUsers[index]['touched'][userFormFields.name.key] = false;
            }
            if (user.email) {
                const { error } = handleFieldError(user.email, userFormFields[userFormFields.email.key]);
                if (error) {
                    updatedAssignUsers[index]['errors'][userFormFields.email.key] = error;
                    updatedAssignUsers[index]['touched'][userFormFields.email.key] = true;
                } else {

                }
            }
            if (user.name && user.name.value) {
                const { error } = handleFieldError(user.name.value, userFormFields[userFormFields.name.key]);
                updatedAssignUsers[index]['errors'][userFormFields.name.key] = error;
                updatedAssignUsers[index]['touched'][userFormFields.name.key] = true;
            }
            // if (user.contact) {
            //     const { error } = handleFieldError(user.contact, userFormFields[userFormFields.contact.key]);
            //     updatedAssignUsers[index]['errors'][userFormFields.contact.key] = error;
            //     updatedAssignUsers[index]['touched'][userFormFields.contact.key] = true;
            // }
            if (name == userFormFields.roleTenantList.key && user.roleTenantList == '') {
                updatedAssignUsers[index]['errors'][userFormFields.roleTenantList.key] = { required: true };
                updatedAssignUsers[index]['touched'][userFormFields.roleTenantList.key] = true;
            } else {
                updatedAssignUsers[index]['errors'][userFormFields.roleTenantList.key] = {};
                updatedAssignUsers[index]['touched'][userFormFields.roleTenantList.key] = false;
            }
            // validation for email 
            if (name == userFormFields.email.key && userFormFieldsData.email.pattern.test(String(value))) {
                searchEmailAndAssignId(name, value, index);
                // let findUserDataExists = accountUsers.find((user) => user.email == value);
                // let findAssignUserData = assignUsers.find((user, indexUser) => user.email == value && index != indexUser);
                // if (findUserDataExists || findAssignUserData) {
                //     updatedAssignUsers[index][name] = '';
                //     message.error('Email already exists');
                //     setAssignUsers(updatedAssignUsers);
                // }
                // else {
                //     const params = {
                //         list: "search",
                //         srch: value
                //     }
                //     let userData = null;
                //     let userId = null;
                //     dispatch(getUserListByEmailAction({ tenantId, authToken, userId, params })).then((responseData) => {
                //         const { responseCode: { status = "" }, responseList = [] } = responseData;
                //         if (isApiCallSuccess(status)) {
                //             if (responseList.length > 0) {
                //                 userData = responseList.find((user) => user.email.toLowerCase() == value.toLowerCase());
                //             }
                //             if (userData) {
                //                 updatedAssignUsers[index]["id"] = userData.id;
                //                 updatedAssignUsers[index]["isActive"] = userData.isActive ? userData.isActive : null;
                //             }
                //             else {
                //                 updatedAssignUsers[index]["isActive"] = 1;
                //                 if (updatedAssignUsers[index].hasOwnProperty("id")) {
                //                     delete updatedAssignUsers[index]['id'];
                //                 }
                //             }
                //             // console.log(updatedAssignUsers,'updatedAssignUsers');
                //             setAssignUsers(updatedAssignUsers);
                //         }


                //     }).catch((err) => {
                //         console.log(err);
                //     })
                // }
            }
            else {
                setAssignUsers(updatedAssignUsers);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    const updateUser = () => {
        try {
            if (validateEditedUser()) {
                let rolesList = rolesDropdownValues();
                const params = {
                    list: "search",
                    srch: editedUser.email
                }
                let isError = false;
                let userData = null;
                let userDataId = null;

                dispatch(getUserListByEmailAction({ tenantId, authToken, userId, params })).then((responseData) => {
                    const { responseCode: { status = "" }, responseList = [] } = responseData;
                    if (isApiCallSuccess(status)) {
                        if (responseList.length > 0) {
                            userData = responseList.find((user) => user.email == editedUser.email);
                            if (userData) {
                                if (editedUser.email == userData.email && userData.id != editedUser.id) {
                                    isError = true;
                                    toast('Fail', 'Email already exists', '');
                                }
                            }
                        }
                    }
                    if (!isError) {
                        if (userData) {
                            userDataId = userData.id;
                        }
                        else {
                            userDataId = editedUser.id;
                        }
                        let filteredRole = rolesList.find(role => role.roleId == editedUser.roleTenantList);
                        const updatedUsers = accountUsers.map(user => {
                            if (user.id == editedUser.id) {
                                return {
                                    ...user,
                                    id: userDataId,
                                    // latest logic
                                    name: editedUser.name,
                                    // name: editedUser.name.label,
                                    email: editedUser.email,
                                    contact: editedUser.contact,
                                    roleTenantList: [{ roleId: editedUser.roleTenantList, isRecActive: +editedUser.userStatus, isActive: 1, roleName: filteredRole.roleName }],
                                    isRecActive: +editedUser.userStatus
                                };
                            }
                            return user;
                        });
                        setOpenModal(false);
                        setAccountUsers(updatedUsers);
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }
        }
        catch (err) {
            console.log(err)
        }
    };

    const validateCredits = () => {
        if (Number(form.addCredit) > 0 && isCreditTransferAllowed()) {
            if (Number(form.addCredit) <= parentTenantBalance) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    };

    const showConfirmation = () => {
        let { errors, valid } = handleError(form, formFields);
        let validAssignUsers = validateAssignUsers();
        if (valid && !validAssignUsers) {
            let validCredits = validateCredits();
            if (validCredits) {
                let confirmationMessage = "Kindly let us know if you'd like to save your changes.";
                toast('confirmation', confirmationMessage);
            } else {
                toast('error', 'Cannot create advertiser due to insufficient wallet balance!');
            }
        }
        setSubmited(true);
        setErrors(errors);
    };

    const handleSubmit = async () => {
        try {
            let addParams = { action: id ? 'update' : 'create' };
            let arr = [];
            if (assignUsers.length > 0) {
                arr = assignUsers
                    .filter(item => item.email.length > 3)
                    .map(item => {
                        let newItem = { ...item };
                        newItem.isRecActive = +newItem.userStatus;
                        newItem.roleTenantList = [{ roleId: Number(newItem.roleTenantList), isRecActive: +newItem.userStatus, isActive: 1 }];
                        return newItem;
                    });
            }

            if (id) {
                arr = [...accountUsers, ...arr];
            }

            // The below code gives access to the account owner email
            // if (addParams.action === 'create') {
            const advertiserType = tenantTypeList.find(tenantType => tenantType.value.toLowerCase() == 'advertiser');
            const accountOwnerData = await getAccountOwnerDetails(form.accountOwnerEmail);
            const defaultRole = rolesList.find(role => role.isActive && role.roleType === 3 && role.tenantType == advertiserType.key);

            if (accountOwnerData && accountOwnerData.length > 0) {
                const isAccountOwnerPresent = arr.some(item => item.email == form.accountOwnerEmail);
                if (!isAccountOwnerPresent && defaultRole) {
                    const accountOwnerUser = accountOwnerData.map(item => ({
                        ...item,
                        roleTenantList: [{ roleId: Number(defaultRole.roleId), isRecActive: 1, isActive: 1 }],
                        isActive: item.isRecActive
                    }));
                    arr = [...arr, ...accountOwnerUser];
                }
            } else {
                const isAccountOwnerPresent = arr.some(item => item.email == form.accountOwnerEmail);
                if (!isAccountOwnerPresent && defaultRole) {
                    const accountOwnerUser = [{
                        name: form.accountOwnerName,
                        email: form.accountOwnerEmail,
                        uID: form.accountOwnerEmail,
                        isActive: 1,
                        isRecActive: 1,
                        roleTenantList: [{ roleId: Number(defaultRole.roleId), isRecActive: 1, isActive: 1 }]
                    }];
                    arr = [...arr, ...accountOwnerUser];
                }
            }
            // uncomment till here
            // }
            // Till here

            form.user = arr;
            const account = tenantList.find(item => item.tenantId == tenantId);
            let tenantData = await getTenantDetails();
            let accountType = ' ';
            let selectedAccountType = form.accountTypeListIds[0]
            let revSelectedAccountType = form.accountTypeListIds[0]
            if (form.accountTypeListIds.length > 1) {
                selectedAccountType = form.accountTypeListIds.join(" & ")
                revSelectedAccountType = form.accountTypeListIds.reverse().join(" & ")
            }
            accountType = get(tenantTypeList.find(a => a.value === selectedAccountType), "key", "")
            if (accountType == "" && form.accountTypeListIds.length > 1)
                accountType = get(tenantTypeList.find(a => a.value === revSelectedAccountType), "key", "")
            form.accountType = parseInt(accountType);
            let userObj = form.user.map(user => (
                console.log(user, user.isRecActive, user.userStatus, 'USER'),
                {
                    name: user.name['label'] ? user.name['label'] : user.name,
                    contact: user.contact, uID: user.email,
                    email: user.email,
                    isRecActive: user.isRecActive,
                    isActive: 1,
                    roleTenantList: user.roleTenantList,
                    id: user.id
                }));
            let data = {
                accountName: form.accountName,
                isActive: form.status,
                user: userObj,
                parentTenantId: account.parentTenantId,
                accountType: parseInt(accountType),
                country: tenantData && tenantData[0].contact.country,
                currencyType: tenantData && tenantData[0].currencyType,
                timezone: getTenantTimeZoneId(tenantId),
                contactPerson: form.accountOwnerName,
                contactEmail: form.accountOwnerEmail,
                miscData: [
                    {
                        key: 'connectionManagement',
                        value: connectionManagement ? 1 : 0
                    }
                ]
            };
            if (id) {
                data.accTenantId = form.accTenantId;
            }
            let res = await addAccount(data, addParams, id);
            const { responseCode: { status = '', msg = '' }, response } = res;
            if (status) {
                if (isApiCallSuccess(status)) {
                    setConnectionManagementMiscData(connectionManagement);
                    setIsUserSaved(true);
                    if (addParams.action == 'create') {
                        setCreatedTenantId(response);
                        await mapDefaultSeats(response);
                        await refreshTenantList();
                        setNewSeat(true);
                    }
                    const pspStripeidObj = pspData && pspData.hasOwnProperty('attributeValues') && pspData.attributeValues.find((ele) => ele.value.toLowerCase() == "stripe")
                    const pspId = +pspStripeidObj.key;
                    let payload = { tenantId: response, isAgency: 1, tenantName: data.accountName };
                    if (id) {
                        payload = { ...payload, tenantId: id };
                    };
                    await mapAdvertiserPaymentType(id ? id : response);
                    if (Number(form.addCredit) > 0 && isCreditTransferAllowed()) {
                        if (Number(form.creditType) == 1) {
                            await addCreditToAdvertiser(payload, form.addCredit, pspId, msg);
                        } else {
                            await debitBalanceFromAdvertiser(payload, form.addCredit, pspId);
                        }
                    } else {
                        toast('success', msg);
                    }
                } else {
                    toast('error', msg);
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    const preservePageState = () => {
        let data = {
            form: form,
            assignUsers: assignUsers,
            createdTenantId: createdTenantId
        };
        localStorage.setItem('pageState', JSON.stringify(data));
    };

    const mapPageState = () => {
        const data = JSON.parse(localStorage.getItem('pageState'));
        if (data) {
            setAssignUsers(data.assignUsers);
            setCreatedTenantId(data.createdTenantId);
            setForm((prevForm) => ({ ...prevForm, ...data.form }));
            localStorage.removeItem('pageState');
            setNewSeat(true);
            setConnectionManagementMiscData(true);
            scrollToElement('agency-seat');
        }
    };

    const showLoading = (spinner) => {
        setShowSpinner(spinner);
    }

    const setContactValidationForTenant = () => {
        const localStorageTenantData = JSON.parse(localStorage.getItem("PreSignInData"));
        const loggedInTenantDetail = localStorageTenantData && localStorageTenantData.responseList && localStorageTenantData.responseList.find((data) => data.tenantId == tenantId);
        const phoneNumberMergedArray = countryCodeConstant.map((data) => {
            const matchingItem = countryLengthConstant.find((data2) => data2.country === data.name);
            if (matchingItem) {
                return { ...data, ...matchingItem };
            } else {
                return data;
            }
        });
        const findLengthPhoneNumber = phoneNumberMergedArray && phoneNumberMergedArray.find((ele) => ele.name == loggedInTenantDetail.contact.country && loggedInTenantDetail.contact.country);
        if (findLengthPhoneNumber && findLengthPhoneNumber.phoneNumberLengthByCountry_phLength) {
            setUserFormFields({
                ...userFormFields,
                contact: {
                    ...userFormFields.contact,
                    minLength: findLengthPhoneNumber.phoneNumberLengthByCountry_phLength,
                    maxLength: findLengthPhoneNumber.phoneNumberLengthByCountry_phLength,
                    minLengthMessage: `Minimum and Maximum ${findLengthPhoneNumber.phoneNumberLengthByCountry_phLength} digit allowed.`,
                    maxLengthMessage: `Minimum and Maximum ${findLengthPhoneNumber.phoneNumberLengthByCountry_phLength} digit allowed.`,
                },
            });
        }
    };

    const fetchParentTenantBalance = async () => {
        let payload = { tenantId: tenantId };
        let parentTenantBalance = await getAccountBalance(payload);
        setParentTenantBalance(parentTenantBalance);
    };

    const initialize = () => {
        getUsersList();
        getRolesList();
        getPaymentConfig();
        getTenantType();
        getUserDetails();
        getPaymentTypes();
        mapPageState();
        setContactValidationForTenant();
        fetchParentTenantBalance();
        if (id) {
            editId(id);
        }
    };

    useEffect(() => {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = props;
            history.push(routes.preSignIn);
        }
        if (!checkConnectionManagementAccess()) {
            setConnectionManagement(false);
        }
        initialize();
    }, []);

    useEffect(() => {
        if (tenantList && tenantList.length > 0) {
            getParentTenant();
        }
    }, [tenantList]);

    useEffect(() => {
        if (accountTypeList && accountTypeList.length > 0) {
            let advertiserData = accountTypeList.find(item => item.value == "Advertiser");
            if (advertiserData) {
                form[formFields.accountType.key] = [advertiserData.value];
                form.accountTypeListIds = [advertiserData.value];
            }
        }
    }, [accountTypeList]);

    return (
        <>
            {showSpinner && <Spinner />}
            {<Modal open={openModal} onClose={() => setOpenModal(false)} size='small' >
                <div className='form__style' style={{ width: '100%', height: '100%', background: '#F7F8FC', boxShadow: '0px 20px 70px rgba(0, 0, 0, 0.25)', borderRadius: 10, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex' }}>
                    <div style={{ alignSelf: 'stretch', height: 76, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex' }}>
                        <div style={{ alignSelf: 'stretch', padding: 20, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                            <div style={{ width: 20, height: 20, position: 'relative', background: 'rgba(255, 255, 255, 0)' }} />
                            <div style={{ color: '#040B1B', fontSize: 24, fontWeight: '500', wordWrap: 'break-word' }}>Edit User</div>
                            <div style={{ width: 20, height: 20, position: 'relative' }}>
                                <button type="button" onClick={() => setOpenModal(false)} className="close" data-dismiss="modal" aria-label="Close">
                                    <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='row p-4 bg-white border'>
                        {/* <div className="col-md-6">
                            <label for={`name`} class="col-sm-6 col-form-label px-0">
                                Name<span className="text-danger">*</span> <br />
                            </label>
                            <CreatableSelect
                                options={userDropdownValues()}
                                onChange={(selected) => setEditedUser({ ...editedUser, [userFormFields.name.key]: selected })}
                                value={editedUser[userFormFields.name.key]}
                                onBlur={(e) => {
                                    if (editedUser.name && editedUser.name.value) {
                                        const { error } = handleFieldError(editedUser.name.value, userFormFields[userFormFields.name.key]);
                                        editedUser['errors'][userFormFields.name.key] = error;
                                        editedUser['touched'][userFormFields.name.key] = true;
                                        setEditedUser({ ...editedUser });
                                    }
                                }}
                                errors={editedUser['errors'][userFormFields.name.key]}
                                setting={userFormFields[userFormFields.name.key]}
                            />
                        </div> */}

                        <div className="col-md-6">
                            <Input
                                onChange={(e) => setEditedUser({ ...editedUser, [userFormFields.email.key]: e.target.value })}
                                onBlur={handleEditedUserTouch}
                                value={editedUser[userFormFields.email.key]}
                                setting={userFormFields[userFormFields.email.key]}
                                error={editedUser['errors'][userFormFields.email.key]}
                                submited={submited}
                                touched={editedUser['touched'][userFormFields.email.key]}
                            />
                        </div>

                        <div className="col-md-6">
                            <Input
                                onChange={(e) => setEditedUser({ ...editedUser, [userFormFields.name.key]: e.target.value })}
                                onBlur={(e) => {
                                    if (editedUser.name) {
                                        const { error } = handleFieldError(editedUser.name, userFormFields[userFormFields.name.key]);
                                        editedUser['errors'][userFormFields.name.key] = error;
                                        editedUser['touched'][userFormFields.name.key] = true;
                                        setEditedUser({ ...editedUser });
                                    }
                                }}
                                value={editedUser[userFormFields.name.key]}
                                setting={userFormFields[userFormFields.name.key]}
                                errors={editedUser['errors'][userFormFields.name.key]}
                                submited={submited}
                                touched={editedUser['touched'][userFormFields.name.key]}
                            />
                        </div>

                        <div className="col-md-6">
                            <Input
                                onChange={(e) => setEditedUser({ ...editedUser, [userFormFields.contact.key]: e.target.value })}
                                onBlur={handleEditedUserTouch}
                                value={editedUser[userFormFields.contact.key]}
                                setting={userFormFields[userFormFields.contact.key]}
                                error={editedUser['errors'][userFormFields.contact.key]}
                                submited={submited}
                                touched={editedUser['touched'][userFormFields.contact.key]}
                            />
                        </div>

                        <div className="col-md-6">
                            {/* <label for={`roleTenantList`} class="col-sm-6 col-form-label px-0">
                                Role<span className="text-danger">*</span>
                            </label> */}
                            <SelectNew
                                onChange={(e) => setEditedUser({ ...editedUser, [userFormFields.roleTenantList.key]: Number(e.target.value) })}
                                onBlur={handleEditedUserTouch}
                                value={editedUser[userFormFields.roleTenantList.key]}
                                setting={userFormFields[userFormFields.roleTenantList.key]}
                                error={editedUser['errors'][userFormFields.roleTenantList.key]}
                                submited={submited}
                                touched={editedUser['touched'][userFormFields.roleTenantList.key]}
                                options={rolesDropdownValues()}
                                disabled={isDefaultRoleDisabled}
                            />
                        </div>

                        <div className="col-md-6 ">
                            {/* <label for={`userStatus`} class="col-sm-6 col-form-label px-0">
                                Status
                            </label> */}
                            <SelectNew
                                onChange={(e) => setEditedUser({ ...editedUser, [userFormFields.userStatus.key]: e.target.value })}
                                onBlur={handleEditedUserTouch}
                                value={editedUser[userFormFields.userStatus.key]}
                                setting={userFormFields[userFormFields.userStatus.key]}
                                error={editedUser['errors'][userFormFields.userStatus.key]}
                                submited={submited}
                                touched={editedUser['touched'][userFormFields.userStatus.key]}
                                options={statusOptions}
                            />
                        </div>
                    </div>

                    <div style={{ alignSelf: 'stretch', padding: 20, justifyContent: 'flex-end', alignItems: 'center', gap: 10, display: 'inline-flex' }}>
                        <div style={{ height: 32, paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, borderRadius: 8, border: '1px #DCE3EE solid', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex', backgroundColor: '#383890' }}>
                            <button className='btn' onClick={() => updateUser()}>
                                <div style={{ textAlign: 'center', color: '#303890', fontSize: 12, fontWeight: '500', wordWrap: 'break-word', color: 'white' }}>Save</div>
                            </button>
                        </div>
                        <div style={{ height: 32, paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, borderRadius: 8, border: '1px #DCE3EE solid', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
                            <button className='btn' onClick={() => setOpenModal(false)}>
                                <div style={{ textAlign: 'center', color: '#303890', fontSize: 12, fontWeight: '500', wordWrap: 'break-word' }}>Cancel</div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>}
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    // path={routes.containers.admin + '/' + routes.admin.account.name}
                    poc={true}
                    idProps={props}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    outSideClickEnable={false}
                />
            }
            <div className="main-panel ion form__style">
                <div className="content-wrapper">
                    <div className="row justify-content-center m-3">
                        <div className="col-md-12 px-0">
                            <div className="card">
                                <div className="p-4 m-2">
                                    <div className="col-md-6 pr-4">
                                        <div className="form-group row">
                                            <label className="col-md-6 px-0">Agency:</label>
                                            <select disabled className='form-select'>
                                                <option>{parentTenant.text}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.accountName.key] ? form[formFields.accountName.key] : ''}
                                                setting={formFields[formFields.accountName.key]}
                                                error={errors[formFields.accountName.key]}
                                                submited={submited}
                                                touched={touched[formFields.accountName.key]}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <SelectNew
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.accountType.key]}
                                                setting={formFields[formFields.accountType.key]}
                                                error={errors[formFields.accountType.key]}
                                                submited={submited}
                                                touched={touched[formFields.accountType.key]}
                                                options={accountTypeList}
                                                disabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.accountOwnerName.key] ? form[formFields.accountOwnerName.key] : ''}
                                                setting={formFields[formFields.accountOwnerName.key]}
                                                error={errors[formFields.accountOwnerName.key]}
                                                submited={submited}
                                                touched={touched[formFields.accountOwnerName.key]}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.accountOwnerEmail.key] ? form[formFields.accountOwnerEmail.key] : ''}
                                                setting={formFields[formFields.accountOwnerEmail.key]}
                                                error={errors[formFields.accountOwnerEmail.key]}
                                                submited={submited}
                                                touched={touched[formFields.accountOwnerEmail.key]}
                                            />
                                        </div>

                                        <div className="col-md-6 ">
                                            <SelectNew
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.status.key]}
                                                setting={formFields[formFields.status.key]}
                                                error={errors[formFields.status.key]}
                                                submited={submited}
                                                touched={touched[formFields.status.key]}
                                                options={sortArray((formFields[formFields.status.key]).options)}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <SelectNew
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.paymentType.key]}
                                                setting={formFields[formFields.paymentType.key]}
                                                error={errors[formFields.paymentType.key]}
                                                submited={submited}
                                                touched={touched[formFields.paymentType.key]}
                                                options={paymentTypes}
                                            />
                                        </div>

                                        {
                                            isCreditTransferAllowed() &&
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label for="addCredit" class="col-sm-4 col-form-label">Set Credit Line</label>
                                                    <div className="row pr-1">
                                                        <div className="col-md-6">
                                                            <SelectNew
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.creditType.key]}
                                                                setting={formFields[formFields.creditType.key]}
                                                                error={errors[formFields.creditType.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.creditType.key]}
                                                                options={getCreditTypeOptions()}
                                                                disabled={id ? false : true}
                                                            />
                                                        </div>

                                                        <div className="col-md-6 pr-0">
                                                            <Input
                                                                onChange={handleChange}
                                                                onBlur={handleTouch}
                                                                value={form[formFields.addCredit.key]}
                                                                setting={formFields[formFields.addCredit.key]}
                                                                error={errors[formFields.addCredit.key]}
                                                                submited={submited}
                                                                touched={touched[formFields.addCredit.key]}
                                                            />
                                                        </div>
                                                        {
                                                            (currentBalance !== null && currentBalance !== undefined) ?
                                                                <p className="text-primary">Current Credit Bal : {currentBalance}</p>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {
                                            checkConnectionManagementAccess() &&
                                            <div className="col-md-6">
                                                <div className='form-group row'>
                                                    <div className="d-flex flex-column mt-2">
                                                        <label for="connectionManagement" class="col-sm-6 col-form-label px-0">Connection Management</label>
                                                        <div className="mt-2">
                                                            <input type="checkbox" id='connectionManagement' checked={connectionManagement} onChange={() => setConnectionManagement(!connectionManagement)} name='connectionManagement' />
                                                            <label for='connectionManagement' className="pl-2 m-0 pt-1" style={{ fontSize: 14 }}>Allowed</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    {
                                        id || accountUsers.length > 0 ?
                                            <div className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <h5 className="pt-2 font-weight-bold">Access allowed to Users</h5>
                                                </div>
                                                <div style={{ padding: '0.5rem 0' }}>
                                                    <div className='campaign-adj'>
                                                        <div className="campaign-list-adj table-responsive">
                                                            <Table
                                                                options={options}
                                                                data={accountUsers}
                                                                handelAction={handleAction}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end">
                                                    <button onClick={() => addNewAdvertisers()} className="btn text-primary px-0">
                                                        <i style={{ fontSize: 18 }} className='ti ti-plus' />
                                                        <span style={{ fontSize: 14 }}>Add New User</span>
                                                    </button>
                                                </div>
                                            </div>
                                            :
                                            null
                                    }

                                    <div className='row my-2'>
                                        {
                                            id ?
                                                null
                                                :
                                                <div className="d-flex justify-content-between">
                                                    <h5 className="pt-2 font-weight-bold mb-2">Assign users to Advertiser</h5>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <button onClick={() => addNewAdvertisers()} className="btn text-primary px-0">
                                                            <i style={{ fontSize: 18 }} className='ti ti-plus' />
                                                            <span style={{ fontSize: 14 }}>Add New User</span>
                                                        </button>
                                                    </div>
                                                </div>
                                        }
                                        {
                                            assignUsers.map((user, index) => {
                                                return (
                                                    <div className="d-flex ml-2">
                                                        {/* <div className="col-md-2 px-0">
                                                            <label for={`name${index}`} class="col-sm-6 col-form-label px-0">
                                                                Name<span className="text-danger">*</span> <br />
                                                            </label>
                                                            <CreatableSelect
                                                                options={userDropdownValues()}
                                                                onChange={(selected) => handleCreatableUser(selected, index)}
                                                                onBlur={(e) => handleBlurAssignUser(e, index)}
                                                                value={user[userFormFields.name.key]}
                                                                errors={user['errors'][userFormFields.name.key]}
                                                                setting={userFormFields[userFormFields.name.key]}
                                                            />
                                                        </div> */}
                                                        
                                                        <div className="col-md-2">
                                                            <Input
                                                                onChange={(e) => handleChangeUser(e, index)}
                                                                onBlur={(e) => handleBlurAssignUser(e, index)}
                                                                value={user[userFormFields.email.key]}
                                                                setting={userFormFields[userFormFields.email.key]}
                                                                error={user['errors'][userFormFields.email.key]}
                                                                submited={submited}
                                                                touched={user['touched'][userFormFields.email.key]}
                                                            />
                                                        </div>

                                                        <div className="col-md-2">
                                                            <Input
                                                                onChange={(e) => handleChangeUser(e, index)}
                                                                onBlur={(e) => handleBlurAssignUser(e, index)}
                                                                value={user[userFormFields.name.key]}
                                                                setting={userFormFields[userFormFields.name.key]}
                                                                errors={user['errors'][userFormFields.name.key]}
                                                                submited={submited}
                                                                touched={user['touched'][userFormFields.name.key]}
                                                            />
                                                        </div>

                                                        <div className="col-md-2">
                                                            <Input
                                                                onChange={(e) => handleChangeUser(e, index)}
                                                                onBlur={(e) => handleBlurAssignUser(e, index)}
                                                                value={user[userFormFields.contact.key]}
                                                                setting={userFormFields[userFormFields.contact.key]}
                                                                error={user['errors'][userFormFields.contact.key]}
                                                                submited={submited}
                                                                touched={user['touched'][userFormFields.contact.key]}
                                                            />
                                                        </div>

                                                        <div className="col-md-2">
                                                            {/* <label for={`roleTenantList${index}`} class="col-sm-6 col-form-label px-0">
                                                                Role<span className="text-danger">*</span>
                                                            </label> */}
                                                            <SelectNew
                                                                onChange={(e) => handleChangeUser(e, index)}
                                                                onBlur={(e) => handleBlurAssignUser(e, index)}
                                                                value={user[userFormFields.roleTenantList.key]}
                                                                setting={userFormFields[userFormFields.roleTenantList.key]}
                                                                error={user['errors'][userFormFields.roleTenantList.key]}
                                                                submited={submited}
                                                                touched={user['touched'][userFormFields.roleTenantList.key]}
                                                                options={rolesDropdownValues()}
                                                            />
                                                        </div>

                                                        <div className="col-md-2">
                                                            {/* <label for={`userStatus${index}`} class="col-sm-6 col-form-label px-0">
                                                                Status
                                                            </label> */}
                                                            <SelectNew
                                                                onChange={(e) => handleChangeUser(e, index)}
                                                                onBlur={() => { }}
                                                                value={user[userFormFields.userStatus.key]}
                                                                setting={userFormFields[userFormFields.userStatus.key]}
                                                                error={user['errors'][userFormFields.userStatus.key]}
                                                                submited={submited}
                                                                touched={user['touched'][userFormFields.userStatus.key]}
                                                                options={statusOptions}
                                                            />
                                                        </div>

                                                        {assignUsers.length > 0 &&
                                                            <div className='col-md-2 d-flex justify-content-start align-items-center'>
                                                                <button onClick={() => removeAssignedUser(index)} className="btn text-primary mt-3">
                                                                    <i style={{ fontSize: 18 }} className='ti ti-minus' />
                                                                    <span style={{ fontSize: 14 }}>Remove</span>
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>

                                    {
                                        seatData && seatData.length > 0 &&
                                        <div className="my-3" style={{ padding: '0.5rem 0' }}>
                                            <div className='campaign-adj'>
                                                <div className="campaign-list-adj table-responsive">
                                                    <Table
                                                        options={platformListOptions}
                                                        data={seatData}
                                                        handelAction={handlePlatformTableAction}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {/* {
                                        newSeat &&
                                        <div className="mt-2 p-0 d-flex justify-content-end">
                                            <button onClick={() => setNewSeat(true)} className="btn btn-primary rounded-2" style={{ backgroundColor: '#383890', padding: '0.625rem 1.125rem' }}>
                                                <i style={{ fontSize: 18 }} className='ti ti-plus text-white' />
                                                <span className="text-white" style={{ fontSize: 14 }}>New Seat</span>
                                            </button>
                                        </div>
                                    } */}

                                    <div id="agency-seat">
                                        {
                                            (newSeat && connectionManagementMiscData) ?
                                                (!campaignSyncVisible && createdTenantId) ?
                                                    <NewSeat onClose={() => setNewSeat(false)} onSave={() => onSeatMapped()} props={props} createdTenantId={createdTenantId} preservePageState={preservePageState} showLoading={showLoading}
                                                        seatType={1}
                                                    />
                                                    :
                                                    null
                                                :
                                                null
                                        }
                                    </div>

                                    {/* {!campaignSyncVisible && createdTenantId && <NewSeat onClose={() => setNewSeat(false)} onSave={() => getSeatData(createdTenantId)} props={props} createdTenantId preservePageState={preservePageState} mapPageState={mapPageState} />} */}
                                    {campaignSyncVisible && createdTenantId && <CampaignSync selectedCampaignSyncAccount={selectedCampaignSyncAccount} onClose={() => setCampaignSyncVisible(false)} onSave={() => setCampaignSyncVisible(false)} isAdvertisers={false} createdTenantId={createdTenantId} props={props} />}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12 py-4 d-flex border justify-content-end" style={{ background: '#F7F8FC', borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}>
                            <button onClick={() => showConfirmation()} className="btn rounded-2" style={{ backgroundColor: '#383890', padding: '0.625rem 1.125rem' }}>
                                <span className="text-white">Save</span>
                            </button>

                            <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}`} className="btn mx-3" style={{ borderRadius: '0.5rem', border: '1px solid #DCE3EE', background: '#FFF', padding: '0.625rem 1.125rem' }}>
                                <span className="text-primary">Close</span>
                            </Link>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default withRouter(AddAccount);
